export function initLogoutButtons(elements) {
    const {logoutBtns, logoutPopup, csrfToken} = elements

    if (!logoutBtns || logoutBtns.length === 0 || !logoutPopup) return

    document.addEventListener(
        "click",
        (event) => {
            const target = event.target.closest(".logoutBtn")
            if (target) {
                event.preventDefault()
                handleLogout()
            }
        },
        {passive: false}
    )

    async function handleLogout() {
        try {
            // Show logout popup immediately
            logoutPopup.classList.add("popup-open")

            // Attempt to call the API
            const response = await fetch("/logout", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "X-CSRF-TOKEN": csrfToken
                },
                body: JSON.stringify({_token: csrfToken})
            })

            // Always redirect regardless of API response
            setTimeout(() => {
                window.location.href = `/${window.translationsData.global_route.locale}`
            }, 500)
        } catch (error) {
            console.error("Network error during logout:", error)
            // Still redirect even if there's an error
            setTimeout(() => {
                window.location.href = `/${window.translationsData.global_route.locale}`
            }, 500)
        }
    }
}
